import dateFormat from 'dateformat';
import VanillaCalendar from 'vanilla-calendar-pro';
import FormField from './field.js';
import FormatDateToOrdinal from '../../utils/formate-date-to-ordinal';

export default class DealerAppointment extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.router = window.HondaRouter;
        this.calendarWrapper = parent.el.querySelector('.calendar_wrapper');
        this.calendarBody = parent.el.querySelector('.calendar_body');
        this.calendarInput = parent.el.querySelector('.calendar_input');
        this.calendarInputValue = parent.el.querySelector('.calendar_input_value');
        this.vanillaCalendarHTML = '';
        this.timeslotContainerWrapper = parent.el.querySelector('.timeslot_container_wrapper');
        this.url = this.el.dataset.url;
        this.data = {};
        this.dealerParam = this.el.dataset.dealerParam;
        this.modelParam = this.el.dataset.modelParam;
        this.dealerLocation = this.el.dataset.dealerLocation;
        this.modelLocation = this.el.dataset.modelLocation;
        this.dealerInput = this.el.dataset.dealerInput;
        this.timeslotWrapper = parent.el.querySelector('.timeslot_wrapper');
        this.hiddenTimeInput = parent.el.querySelector('.timeslot');
        this.hiddenDateInput = parent.el.querySelector('.dateSlot');
        this.calendarInputPlaceholder = this.calendarInputValue.textContent;
        this.timeslotPlaceholder = this.timeslotWrapper.innerHTML;
        this.loaderDiv = this.el.querySelector('.form_builder_loader');
        this.timeslotTemplate = _.template(parent.el.querySelector('#timeslot_template').innerHTML.replaceAll('\\', ''));
        this.noTimeslotTemplate = _.template(parent.el.querySelector('#no_timeslot_template').innerHTML.replaceAll('\\', ''));
        this.currentDateSelected = '';
        this.bind();
    }

    bind() {
        window.addEventListener('hashchange', () => this.reset());
        this.calendarInput.addEventListener('click', () => {
            this.calendarInit();
        });

        this.calendarInput.addEventListener('keydown', (e) => {
            if (e.code === 'Enter') {
                this.calendarInit();
            }
        });

        this.timeslotWrapper.addEventListener('change', (e) => {
            this.hiddenTimeInput.value = e.target.value;
            const selectedOption = this.timeslotWrapper.options[this.timeslotWrapper.options.selectedIndex];
            this.router?.setData('selectedTime', selectedOption.innerHTML);
            this.update();
        });
    }

    calendarInit() {
        if (!this.calendar) {
            this.init();
        }
        this.toggleCalendar();
        this.updateCalendar();
    }

    dealer() {
        if (this.dealerLocation === 'hash') {
            return new URLSearchParams(window.location.hash.split('?')[1] || '').get(this.dealerParam);
        } if (this.dealerLocation === 'query') {
            return new URLSearchParams(window.location.search || '').get(this.dealerParam);
        } if (this.dealerLocation === 'field' && this.dealerInput) {
            return this.dealerInput.value;
        }
    }

    model() {
        if (this.modelLocation === 'hash') {
            return new URLSearchParams(window.location.hash.split('?')[1] || '').get(this.modelParam);
        } if (this.modelLocation === 'query') {
            return new URLSearchParams(window.location.search || '').get(this.modelParam);
        }
    }

    getCalendarLanguage() {
        const htmlLang = (document.documentElement.getAttribute('lang') || '').trim().toLowerCase();

        if (!htmlLang) {
            return 'en';
        }

        // VanillaCalendar expects language keys like "en", "de", etc.
        return htmlLang.split('-')[0];
    }

    init() {
        const self = this;
        this.calendar = new VanillaCalendar(self.calendarBody, {
            settings: {
                lang: this.getCalendarLanguage(),
                iso8601: false,
                visibility: {
                    theme: 'light',
                    today: false,
                },
                range: {
                    disablePast: true,
                    disabled: [dateFormat(new Date(), 'yyyy-mm-dd')],
                },
            },
            actions: {
                clickDay(event, dates) {
                    self.clearHiddenInput();
                    self.toggleCalendar();
                    self.setSelectedDate(dates?.selectedDates?.[0]);
                    self.updateCalendar();
                },
                clickMonth() {
                    self.updateCalendar();
                },
                clickYear() {
                    self.updateCalendar();
                },
                clickArrow() {
                    self.updateCalendar();
                },
            },
        });
        this.calendar.init();
    }

    clearHiddenInput() {
        this.hiddenDateInput.value = '';
        this.hiddenTimeInput.value = '';
    }

    getDateSlot(minDateOfBooking, maxDateOfBooking, datesList) {
        this.loaderDiv.classList.remove('hide');
        const body = JSON.stringify({
            dealerCode: this.dealer(),
            modelCode: this.model(),
            startDate: minDateOfBooking,
            endDate: maxDateOfBooking,
        });

        fetch(this.url, { method: 'POST', body })
            .then((response) => response.json())
            .then((json) => this.data = json )
            .then((json) => this.populateDates(json, datesList))
            .catch(() => {
                this.populateDates({}, datesList);
            });
    }

    populateDates(data, datesList) {
        const enableDates = Object.keys(data);
        const disableDates = datesList.filter((date) => !enableDates.includes(date));
        this.calendar.settings.range.disabled = [dateFormat(new Date(), 'yyyy-mm-dd'), ...disableDates];
        this.calendar.settings.selected.dates = [this.currentDateSelected];
        this.calendar.update({
            dates: true,
        });
        const dateListArray = [...this.vanillaCalendarHTML.querySelectorAll('.vanilla-calendar-day__btn')];
        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0];
        const datesUpToToday = [];

        dateListArray.some((el) => {
            const { calendarDay } = el.dataset;

            if (calendarDay <= formattedToday) {
                datesUpToToday.push(calendarDay);
                el.classList.add('inactive_date');
                return false;
            }
            return true;
        });

        // Now you can use datesUpToToday as needed
        this.loaderDiv.classList.add('hide');
    }

    populateTimeslot(selectedDate) {
        const selectedDateString = `${selectedDate}`;
        const slotData = this?.data[selectedDateString] ?? [];
        let html = '';
        if (slotData.length > 0) {
            html = this.timeslotTemplate({ slotData, dateFormat });
        } else {
            html = this.noTimeslotTemplate();
        }
        this.timeslotWrapper.innerHTML = html;
        this.timeslotContainerWrapper.classList.remove('disabled');
        this.timeslotContainerWrapper.setAttribute('aria-disabled', 'false');
        this.timeslotWrapper.removeAttribute('disabled');
    }

    reset() {
        this.calendarInputValue.innerHTML = this.calendarInputPlaceholder;
        this.calendarInput.classList.remove('selected');
        this.timeslotWrapper.innerHTML = this.timeslotPlaceholder;
        this.timeslotContainerWrapper.classList.add('disabled');
        this.timeslotContainerWrapper.setAttribute('aria-disabled', 'true');
        this.timeslotWrapper.setAttribute('disabled', '');
        this.currentDateSelected = '';
        this.router?.setData('selectedDate', '');
        this.router?.setData('selectedTime', '');
        this.calendar?.update();
        this.clearHiddenInput();
    }

    setSelectedDate(selectedDate) {
        this.calendarInput.classList.add('selected');
        if (selectedDate) {
            this.calendarInputValue.innerHTML = FormatDateToOrdinal.dateFormate(selectedDate);
            this.router?.setData('selectedDate', this.calendarInputValue.innerHTML);
            this.router?.setData('selectedTime', '');
            this.hiddenDateInput.value = selectedDate;
            this.currentDateSelected = selectedDate;
            this.populateTimeslot(selectedDate);
        } else {
            this.reset();
        }
    }

    toggleCalendar() {
        this.calendarWrapper.classList.toggle('active');
    }

    updateCalendar = _.debounce(() => {
        const Today = new Date();
        const Tomorrow = new Date();
        Tomorrow.setDate(Tomorrow.getDate() + 1);
        this.vanillaCalendarHTML = this.calendar.HTMLElement;
        const dateListArray = [...this.vanillaCalendarHTML.querySelectorAll('.vanilla-calendar-day__btn')];
        const datesList = dateListArray.map((el) => el.dataset.calendarDay);
        const minDate = datesList[0] <= Today ? Tomorrow : datesList[0];
        const maxDate = datesList[datesList.length - 1];
        this.getDateSlot(minDate, maxDate, datesList);
    }, 100);

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_dealer_appointment');
    }
}
